import { render, staticRenderFns } from "./TijdsregistratieLijst.vue?vue&type=template&id=5df5adc0&"
import script from "./TijdsregistratieLijst.vue?vue&type=script&lang=js&"
export * from "./TijdsregistratieLijst.vue?vue&type=script&lang=js&"
import style0 from "./TijdsregistratieLijst.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/koen/co/sociare/werktijd_mobile/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VDatePicker,VDialog,VIcon,VProgressCircular,VSpacer})
